// Actions
import { LoginActions, LoginActionTypes } from './login.actions';

// Models
import { LoginState } from './login.state';

const defaultState: LoginState = {
    accessToken: '',
    refreshToken: '',
    expireIn: null,
    result: null,
    error: {
        id: null,
        description: null,
    },
    errorType: null,
    logged: null,
    logout: null,
};

export type Action = LoginActions;

export function LoginReducer(state = defaultState, action: any) {
    // console.log(action.type);
    switch (action.type) {
        case LoginActionTypes.DO_LOGIN_USER_SUCCESS:
        case LoginActionTypes.DO_AUTOLOGIN_USER_SUCCESS:
            return {
                ...state,
                logged: true,
                logout: false,
                accessToken: action.payload.access_token,
                refreshToken: action.payload.refresh_token,
                expireIn: action.payload.expire_in,
                result: action.payload,
                error: null,
                errorType: null,
            };

        case LoginActionTypes.DO_LOGIN_USER_FAIL:
            return {
                ...state,
                logged: false,
                result: action.payload,
                error: action.payload.error,
                errorType: 'login',
            };
        case LoginActionTypes.DO_AUTOLOGIN_USER_FAIL:
            return {
                ...state,
                logged: false,
                result: action.payload.result,
                error: action.payload.error,
                errorType: 'autologin',
            };

        case LoginActionTypes.DO_LOGIN_USER_RESET:
            return {
                ...state,
                accessToken: '',
                refreshToken: '',
                expireIn: null,
                error: {
                    id: null,
                    description: null,
                },
                errorType: null,
                logged: false,
                logout: true,
            };

        case LoginActionTypes.DO_LOGIN_RESET_ERROR:
            return {
                ...state,
                errorType: null,
            };

        default:
            return state;
    }
}
